module.exports = __webpack_public_path__ + "img/logo.a5955061.png";